<template lang="pug">
  #wrapper
    Header
    main
      #title クリニックを探す
      #search.m-card-1
        //-.card-title 絞り込み検索
        .inner
          .menus
            //- 住所で検索
            h3.card-head 住所で検索
            .address
              .zip
                p.m-card-1__title 郵便番号
                input.input-title(type="text" name="zip" v-model="zip" @keyup="yubinbango()")
              .pref
                p.m-card-1__title 所在地
                select( v-model="pref_id")
                  option(value="" selected hidden) 都道府県
                  option(v-for="item in prefectures" :value="item.id") {{item.name}}
                //-input.input-title(type="text" name="pref_name" v-model="pref_name" @change="prefChange")
                .address1
                  input.input-title(type="text" name="address1" v-model="address1")

            //- サービス
              h3.card-head 医療サービスで検索
              .service
                .service-item
                  input(type="checkbox" id="night" name="night" v-model="service.night" true-value=1 false-value=0)
                  label.check-label(for="night") 夜間診療（19時以降）
                .service-item
                  input(type="checkbox" id="female" name="female" v-model="service.female" true-value=1 false-value=0)
                  label.check-label(for="female") 女性医師
                .service-item
                  input(type="checkbox" id="credit" name="credit" v-model="service.credit" true-value=1 false-value=0)
                  label.check-label(for="credit") クレジットカード払
                .service-item
                  input(type="checkbox" id="loan" name="loan" v-model="service.loan" true-value=1 false-value=0)
                  label.check-label(for="loan") 分割・ローン払
                .service-item
                  input(type="checkbox" id="reservation" name="reservation" v-model="service.reservation" true-value=1 false-value=0)
                  label.check-label(for="reservation") 完全予約制
                .service-item
                  input(type="checkbox" id="freeCounseling" name="freeCounseling" v-model="service.freeCounseling" true-value=1 false-value=0)
                  label.check-label(for="freeCounseling") 無料カウンセリング
                .service-item
                  input(type="checkbox" id="secondOpinion" name="secondOpinion" v-model="service.secondOpinion" true-value=1 false-value=0)
                  label.check-label(for="secondOpinion") セカンドオピニオン
                .service-item
                  input(type="checkbox" id="implant" name="implant" v-model="service.implant" true-value=1 false-value=0)
                  label.check-label(for="implant") インプラント保証
                .service-item
                  input(type="checkbox" id="holiday" name="holiday" v-model="service.holiday" true-value=1 false-value=0)
                  label.check-label(for="holiday") 土日診療
                .service-item
                  input(type="checkbox" id="visit" name="visit" v-model="service.visit" true-value=1 false-value=0)
                  label.check-label(for="visit") 訪問診療

              //- 設備
              h3.card-head 設備で検索
              .facility
                .facility-item
                  input(type="checkbox" id="parking" name="parking" v-model="service.parking" true-value=1 false-value=0)
                  label.check-label(for="parking") 駐車場
                .facility-item
                  input(type="checkbox" id="barrierFree" name="barrierFree" v-model="service.barrierFree" true-value=1 false-value=0)
                  label.check-label(for="barrierFree") バリアフリー
                .facility-item
                  input(type="checkbox" id="kidsSpace" name="kidsSpace" v-model="service.kidsSpace" true-value=1 false-value=0)
                  label.check-label(for="kidsSpace") キッズスペース
                .facility-item
                  input(type="checkbox" id="private" name="private" v-model="service.private" true-value=1 false-value=0)
                  label.check-label(for="private") 個室診療
                .facility-item
                  input(type="checkbox" id="counselingRoom" name="counselingRoom" v-model="service.counselingRoom" true-value=1 false-value=0)
                  label.check-label(for="counselingRoom") カウンセリングルーム
                .facility-item
                  input(type="checkbox" id="operationRoom" name="operationRoom" v-model="service.operationRoom" true-value=1 false-value=0)
                  label.check-label(for="operationRoom") オペ室
                .facility-item
                  input(type="checkbox" id="recoveryRoom" name="recoveryRoom" v-model="service.recoveryRoom" true-value=1 false-value=0)
                  label.check-label(for="recoveryRoom") リカバリールーム
                .facility-item
                  input(type="checkbox" id="hospitalize" name="hospitalize" v-model="service.hospitalize" true-value=1 false-value=0)
                  label.check-label(for="hospitalize") 入院設備
                .facility-item
                  input(type="checkbox" id="ct" name="ct" v-model="service.ct" true-value=1 false-value=0)
                  label.check-label(for="ct") 歯科用ＣＴ撮影
                .facility-item
                  input(type="checkbox" id="three_d" name="three_d" v-model="service.three_d" true-value=1 false-value=0)
                  label.check-label(for="three_d") 3Dシュミレーション診断
                .facility-item
                  input(type="checkbox" id="laser" name="laser" v-model="service.laser" true-value=1 false-value=0)
                  label.check-label(for="laser") レーザー治療
                .facility-item
                  input(type="checkbox" id="anesthesia" name="anesthesia" v-model="service.anesthesia" true-value=1 false-value=0)
                  label.check-label(for="anesthesia") 静脈鎮静麻酔・全身麻酔
                .facility-item
                  input(type="checkbox" id="microscope" name="microscope" v-model="service.microscope" true-value=1 false-value=0)
                  label.check-label(for="microscope") マイクロスコープ精密治療

          btnS.search(btnTxt="検索" color="neutral" @click="search")
    Footer

</template>
<script>
import common from "@/lib/common.js";
import API from "@/lib/api";
import { Core as YubinBangoCore } from "yubinbango-core";
import btnS from "@/components/common/btnS.vue";
import Header from "@/components/headerC";
import Footer from "@/components/footerC";
export default {
  name: "clinicSearch",
  metaInfo() {
    return {
      title:
        "クリニックを探す｜DIOデジタル株式会社｜インプラント・歯科医療用各種機器・材料",
      meta: [
        {
          name: "description",
          content:
            "住所で検索. 全国の地域からDIOインプラントを使用する歯科医院を検索することが出来ます。",
        },
        { name: "keywords", content: "" },
      ],
    };
  },
  data: function () {
    return {
      baseURL: process.env.VUE_APP_PROXY_PATH,
      items: [],
      zip: "",
      pref_name: "",
      pref_id: "",
      address1: "",

      service: {
        night: 0,
        female: 0,
        credit: 0,
        loan: 0,
        reservation: 0,
        freeCounseling: 0,
        secondOpinion: 0,
        implant: 0,
        holiday: 0,
        visit: 0,
      },
      facility: {
        parking: 0,
        barrierFree: 0,
        kidsSpace: 0,
        private: 0,
        counselingRoom: 0,
        operationRoom: 0,
        recoveryRoom: 0,
        hospitalize: 0,
        ct: 0,
        three_d: 0,
        laser: 0,
        anesthesia: 0,
        microscope: 0,
      },
      cities: [],
      searchAreaOpen: false,
    };
  },
  mixins: [common],
  components: {
    btnS,
    Header,
    Footer,
  },
  methods: {
    yubinbango() {
      new YubinBangoCore(this.zip, (addr) => {
        this.pref_name = addr.region; // 都道府県
        this.address1 += addr.locality; // 市区町村
        this.address1 += addr.street; // 町域
        this.pref_id = this.getPrefNum(addr.region);
      });
    },
    async search() {
      console.log("search()");
      ///this.zipにハイフンが無ければ追加
      if (this.zip.length === 7) {
        this.zip = this.zip.slice(0, 3) + "-" + this.zip.slice(3);
      }
      let postParam = {};
      this.zip ? (postParam["zip"] = this.zip) : null;
      this.pref_id ? (postParam["pref_id"] = this.pref_id) : null;
      this.address1 ? (postParam["address1"] = this.address1) : null;
      let service = {};
      this.service.night ? (service["night"] = this.service.night) : null;
      this.service.female ? (service["female"] = this.service.female) : null;
      this.service.credit ? (service["credit"] = this.service.credit) : null;
      this.service.loan ? (service["loan"] = this.service.loan) : null;
      this.service.reservation
        ? (service["reservation"] = this.service.reservation)
        : null;
      this.service.freeCounseling
        ? (service["freeCounseling"] = this.service.freeCounseling)
        : null;
      this.service.secondOpinion
        ? (service["secondOpinion"] = this.service.secondOpinion)
        : null;
      this.service.implant ? (service["implant"] = this.service.implant) : null;
      this.service.holiday ? (service["holiday"] = this.service.holiday) : null;
      this.service.visit ? (service["visit"] = this.service.visit) : null;

      postParam["service"] = service;

      let facility = {};
      this.facility.parking
        ? (facility["parking"] = this.facility.parking)
        : null;
      this.facility.barrierFree
        ? (facility["barrierFree"] = this.facility.barrierFree)
        : null;
      this.facility.kidsSpace
        ? (facility["kidsSpace"] = this.facility.kidsSpace)
        : null;
      this.facility.private
        ? (facility["private"] = this.facility.private)
        : null;
      this.facility.counselingRoom
        ? (facility["counselingRoom"] = this.facility.counselingRoom)
        : null;
      this.facility.operationRoom
        ? (facility["operationRoom"] = this.facility.operationRoom)
        : null;
      this.facility.recoveryRoom
        ? (facility["recoveryRoom"] = this.facility.recoveryRoom)
        : null;
      this.facility.hospitalize
        ? (facility["hospitalize"] = this.facility.hospitalize)
        : null;
      this.facility.ct ? (facility["ct"] = this.facility.ct) : null;
      this.facility.three_d
        ? (facility["three_d"] = this.facility.three_d)
        : null;
      this.facility.laser ? (facility["laser"] = this.facility.laser) : null;
      this.facility.anesthesia
        ? (facility["anesthesia"] = this.facility.anesthesia)
        : null;
      this.facility.microscope
        ? (facility["microscope"] = this.facility.microscope)
        : null;

      postParam["facility"] = facility;

      console.log({ postParam });
      let params = new URLSearchParams();
      let json = "";
      if (postParam) {
        json = JSON.stringify(postParam);
      }
      params.append("data", json);

      console.log(params);
      const api = new API();
      let data = await api.post("/clinic/implant/1", params);
      console.log({ data });
      this.$router.push({
        name: "archive",
        params: {
          searchData: data,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/css/utility/_colors" as colors;
@use "@/css/utility/_mixin" as mixin;
@use "@/css/utility/_media" as media;
@use "@/css/utility/_font" as font;
@use "@/css/utility/_variables" as variables;

#search {
  @include mixin.liquidSize(width, 1060, 345);
  @include mixin.liquidSize(margin-bottom, 0, 30);
  @include mixin.liquidSize(padding, 0, 0);

  margin-left: auto;
  margin-right: auto;
  position: relative;
}
.card-title {
  background: #df6d96;
  @include mixin.liquidSize(height, 45, 45);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 13px;
  font-weight: 700; /* bold */
  letter-spacing: 0.05em;
  @include mixin.liquidSize(margin-bottom, 5, 5);
}
.inner {
  @include mixin.liquidSize(padding-left, 30, 20);
  @include mixin.liquidSize(padding-right, 30, 20);
  @include mixin.liquidSize(padding-top, 50, 20);
  @include mixin.liquidSize(padding-bottom, 30, 30);
  box-sizing: border-box;
}

.card-head {
  @include mixin.liquidSize(font-size, 22, 16);
  font-weight: 700; /* bold */
  letter-spacing: 0.05em;
  line-height: 1.75;
  color: #141414;
  border-bottom: solid 2px #df6d96;
  @include mixin.liquidSize(padding-bottom, 7, 7);
  @include mixin.liquidSize(padding-left, 10, 10);
  @include mixin.liquidSize(padding-right, 10, 10);
  box-sizing: border-box;
  @include mixin.liquidSize(margin-bottom, 30, 20);
}
// 住所で検索
.address {
  @include media.min-screen(media.$breakpoint-md) {
    display: flex;
  }
}

.zip,
.pref {
  //@include mixin.liquidSize(padding-left, 30, 0);
  //@include mixin.liquidSize(padding-right, 30, 0);
  @include media.min-screen(media.$breakpoint-md) {
    width: 30%;
    box-sizing: border-box;
  }
}

.zip {
  //@include mixin.liquidSize(padding-left, 30, 0);
  @include media.min-screen(media.$breakpoint-md) {
    width: 25%;
    margin-right: 5%;
  }
}
.pref {
  @include media.min-screen(media.$breakpoint-md) {
    width: 40%;
  }
}

.title {
  font-size: 13px;
  font-weight: 700; /* bold */
  letter-spacing: 0.05em;
  line-height: 1.75;
  color: #141414;
  text-decoration: underline;
}

.btn {
  background: #df6d96;
  color: #fff;
  font-weight: 500; /* medium */
  letter-spacing: 0.05em;
  @include mixin.liquidSize(font-size, 12, 12);
  @include mixin.liquidSize(width, 100, 100);
  @include mixin.liquidSize(height, 30, 30);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  margin: auto 0 0 auto;
}

//住所
select,
input,
textarea {
  font-size: 14px;
  letter-spacing: 0.05em;
  font-weight: 500; /* medium */
  color: #89868b;
  font-family: "Noto Sans JP";
  border-radius: 6px;
}

.input-title {
  border: solid 1px #e9e9e9;
  border-radius: 6px;
  width: 100%;
  @include mixin.liquidSize(height, 40, 40);
  box-sizing: border-box;
  padding: 0 15px;
  margin-bottom: 30px;
}

select {
  box-sizing: border-box;
  border: solid 1px #e9e9e9;
  width: 100%;
  @include mixin.liquidSize(height, 40, 40);
  border-radius: 6px;
  @include mixin.liquidSize(margin-bottom, 10, 10);
  padding: 0 15px;
  background: {
    image: url(../assets/icon-selectbox.svg);
    position: center right 15px;
    repeat: no-repeat;
  }
}

input[type="checkbox"] {
  display: none;
  &:checked + label {
    &:before {
      background: {
        image: url(../assets/icon-check.svg);
        repeat: no-repeat;
        position: center center;
        size: 20px auto;
      }
    }
  }
}
.check-label {
  color: #89868b;
  font-size: 13px;
  letter-spacing: 0.05em;
  font-weight: 700; /* bold */
  display: flex;
  align-items: center;
  line-height: 1;
  cursor: pointer;
  &:before {
    content: "";
    box-sizing: border-box;
    border: solid 1px #e9e9e9;
    width: 30px;
    height: 30px;
    border-radius: 6px;
    display: inline-block;
    margin-right: 10px;
  }
}

.service,
.facility {
  @include media.min-screen(media.$breakpoint-md) {
    display: flex;
    flex-wrap: wrap;
  }
}
.service {
  @include mixin.liquidSize(margin-bottom, 30, 20);
}
.service-item,
.facility-item {
  @include mixin.liquidSize(margin-right, 30, 0);
  @include mixin.liquidSize(margin-bottom, 25, 10);
}

.search {
  @include mixin.liquidSize(margin-top, 30, 40);
  margin-left: auto;
  margin-right: auto;
  display: block;
}
</style>
